import { render } from "./configuracoesCampeonatoView.vue?vue&type=template&id=6971c537&scoped=true"
import script from "./configuracoesCampeonatoView.vue?vue&type=script&lang=js"
export * from "./configuracoesCampeonatoView.vue?vue&type=script&lang=js"

import "./configuracoesCampeonatoView.vue?vue&type=style&index=0&id=6971c537&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6971c537"]])

export default __exports__